import { createFileRoute, redirect } from "@tanstack/react-router";
import { ChatsPage } from "../../../components/chats/chats-page";
import { chatsSearchSchema } from "../../../lib/chats/search-params";

/**
 * Every chat, and a search through what was said in them. The search and the filters
 * live in the address (see `chatsSearchSchema`), so back from an open chat lands on the same list.
 */
export const Route = createFileRoute("/_authenticated/_workspace/chats/")({
  validateSearch: chatsSearchSchema,
  // A new chat was once a panel beside this list (`new`); links and bookmarks to it open the page.
  beforeLoad: ({ search }) => {
    if (search.new) {
      throw redirect({
        to: "/chats/new",
        search: {
          ...(search.record ? { record: true } : {}),
          ...(search.prompt ? { prompt: search.prompt } : {}),
        },
        replace: true,
      });
    }
  },
  component: function ChatsRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ChatsPage
        search={search}
        onChange={(patch) =>
          // Typing in the search box is not a page change: replace the entry, and skip the
          // page-wide view transition that would otherwise replay on every keystroke settling.
          void navigate({
            search: (previous) => ({ ...previous, ...patch }),
            replace: true,
            viewTransition: false,
          })
        }
      />
    );
  },
});
